import { Box, Button, Typography, styled } from "@mui/material";
import React from "react";

import { useDeviceWidth } from "src/hooks/useDeviceWidth";

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isTabletMobile",
})<{ isTabletMobile: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  padding: ${({ theme }) => theme.spacing(2)};
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${({ isTabletMobile, theme }) => theme.spacing(isTabletMobile ? 4 : 8)};
`;

const StyledButtonWhite = styled(Button)`
  background-color: ${({ theme }) => theme.palette.common.white};
  color: ${({ theme }) => theme.palette.secondary.main};

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.dark};
    color: ${({ theme }) => theme.palette.secondary.contrastText};
  }
`;
interface Props {
  onLogout(): void;
}

export const ErrorGlobal = ({ onLogout }: Props) => {
  const { isTabletMobile } = useDeviceWidth();

  return (
    <StyledContainer isTabletMobile={isTabletMobile}>
      <Typography
        variant={isTabletMobile ? "h6" : "h3"}
        sx={{ px: isTabletMobile ? 2 : 8, textTransform: "uppercase", fontWeight: "bold" }}
      >
        Votre espace client est temporairement indisponible
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography
          variant={isTabletMobile ? "subtitle2" : "h6"}
          sx={{ px: isTabletMobile ? 2 : 8 }}
        >
          Nous vous remercions de votre visite ! Votre espace client est actuellement en cours de
          maintenance.
        </Typography>
        <Typography
          variant={isTabletMobile ? "subtitle2" : "h6"}
          sx={{ px: isTabletMobile ? 2 : 8 }}
        >
          Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée.
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 250, gap: 2 }}>
        <StyledButtonWhite
          size="large"
          variant="contained"
          onClick={() => window.location.reload()}
        >
          Recharger la page
        </StyledButtonWhite>

        <StyledButtonWhite
          size="large"
          variant="contained"
          onClick={() => {
            onLogout();
            window.location.reload();
          }}
        >
          Déconnexion
        </StyledButtonWhite>
      </Box>
    </StyledContainer>
  );
};
